import React from 'react';

const Contact = () => {
    const contactEmail = process.env.REACT_APP_EMAIL || 'palahuddinalkhalid@gmail.com';

    const showcaseItems = [
        {
            label: 'POS Platforms',
            value: 'Multi-branch',
            detail: 'Live operations, inventory flows, and role-based access.'
        },
        {
            label: 'Mobile Apps',
            value: 'Flutter',
            detail: 'Touch-first interfaces for field and portfolio experiences.'
        },
        {
            label: 'Teams',
            value: 'ZeroOne + PERATI',
            detail: 'Startup work, client deployments, and product collaboration.'
        }
    ];

    return (
        <section id="contact" className="section" aria-labelledby="contact-heading">
            <div className="section-content">
                <h2 id="contact-heading" className="visually-hidden">Contact</h2>
                <p>
                    Open to collaborations and new challenges—let's connect!
                </p>
                <p>
                    Currently seeking opportunities to contribute to impactful work while continuing to grow as a developer.
                </p>

                <div className="showcase-strip" aria-label="Portfolio showcase highlights">
                    {showcaseItems.map((item) => (
                        <article className="showcase-card" key={item.label}>
                            <span className="showcase-label">{item.label}</span>
                            <strong>{item.value}</strong>
                            <p>{item.detail}</p>
                        </article>
                    ))}
                </div>

                <div className="contact-info">
                    <a href={`mailto:${contactEmail}`} className="contact-link" aria-label="Send email">
                        {contactEmail}
                    </a>
                </div>
                <div className="footer-note">
                    <p>
                        Designed and coded in <a href="https://code.visualstudio.com/" target="_blank" rel="noopener noreferrer">Visual Studio Code</a> by
                        yours truly. Built with <a href="https://reactjs.org/" target="_blank" rel="noopener noreferrer">React.js</a>,
                        hosted on <a href="https://vercel.com/" target="_blank" rel="noopener noreferrer">Vercel</a>, and
                        domain managed through <a href="https://godaddy.com/" target="_blank" rel="noopener noreferrer">GoDaddy</a>.
                    </p>
                </div>

                <div className="copyright-footer">
                    <p>&copy; Al Khalid Muksan Palahuddin</p>
                </div>
            </div>
        </section>
    );
};

export default Contact;
